import Typography from '@mui/material/Typography'
import type { BaseReport, LightningReport, LightningReportScheduleFrequency } from '@xweather/protect-types'
import { isNotNil } from 'es-toolkit'
import { useTranslation } from 'react-i18next'
import { Box } from '../../components/Box.tsx'
import { Chip } from '../../components/generic.tsx'
import { I18n } from '../../components/I18n.tsx'
import { Stack } from '../../components/Stack.tsx'
import { useFormatDate } from '../preferences/useFormatDate.tsx'
import { ReportSummaryHeader, TimezoneLabel } from './ReportSummaryHeader.tsx'

export const LightningReportFormPageSummaryHeader = ({
	timeRange,
	radiusKm,
	assetVrns,
	customPoint,
	dataset,
	timezone,
	frequency,
	scheduleRange,
}: {
	timeRange?: LightningReport['timeRange']
	radiusKm: LightningReport['radiusKm']
	assetVrns: BaseReport['assetVrns']
	customPoint: LightningReport['customPoint']
	dataset: LightningReport['dataset']
	timezone: string
	frequency?: LightningReportScheduleFrequency
	scheduleRange?: { startScheduleAt: string; endScheduleAt?: string }
}) => {
	const { t } = useTranslation()
	const formatDate = useFormatDate()

	return (
		<ReportSummaryHeader
			assetVrns={assetVrns}
			radiusKm={radiusKm}
			customPoint={customPoint}
			timezone={timezone}
			timeRange={timeRange}
			areaDetails={
				<I18n
					i18nKey={($) => $.reports.lightning.common.summaryBanner.selectedDataset}
					values={{
						dataset: t(($) => $.reports.lightning.common.datasets[dataset]),
					}}
				/>
			}
		>
			{(frequency || scheduleRange) && (
				<Stack col>
					{scheduleRange && (
						<Stack align='center' flexWrap='wrap' rowGap={0}>
							<Typography variant='body1'>
								<I18n
									i18nKey={($) => $.reports.lightning.common.summaryBanner.scheduleRange}
									values={{
										start: formatDate(scheduleRange.startScheduleAt, 'DD.MM.YYYY.HH.mm', 'UTC'),
										end: scheduleRange.endScheduleAt
											? formatDate(scheduleRange.endScheduleAt, 'DD.MM.YYYY.HH.mm', 'UTC')
											: t(($) => $.reports.lightning.common.subscriptionEndDate),
									}}
								/>
							</Typography>
							<TimezoneLabel times={[scheduleRange.startScheduleAt, scheduleRange.endScheduleAt].filter(isNotNil)} timezone={timezone} />
						</Stack>
					)}
					{frequency && (
						<Box>
							<Chip variant='filled' label={t(($) => $.reports.lightning.common.frequencies[frequency])} />
						</Box>
					)}
				</Stack>
			)}
		</ReportSummaryHeader>
	)
}
